import './PortProductLinePage.css'
import 'antd/dist/reset.css'
import React from 'react'
import PortBottomLayout from '../../common/PortBottomLayout'

export default class PortOnsiteGuidancePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="PortProductLine">
          <div className="PortProductLineTitle">
            Keystride现场工程指导服务介绍
          </div>
          <div className="PortProductLineSubtitle">一、服务定位</div>
          <div className="PortProductLineText">
            江苏凯士达阀门科技有限公司基于在仪表管阀件领域的深厚技术积累与工程经验，推出“全流程现场工程支持服务”，专注于解决客户在设备安装、系统调试、运维优化等环节的实操难题。我们以“技术下沉、服务前移”为理念，通过专业团队驻场指导，确保从产品到系统的无缝衔接，帮助客户规避施工风险、缩短项目周期、提升运维效率。
          </div>

          <div className="PortProductLineSubtitle">二、服务内容</div>
          <div className="PortProductLineSmallTitle">1.现场勘测与方案适配</div>
          <div className="PortProductLineText">
            -
            工况复验：实地测量管路走向、设备布局、环境参数（温度/振动/空间限制），验证设计方案的可行性。
          </div>
          <div className="PortProductLineText">
            -
            风险预判：针对复杂场景（如多介质交叉管路、高危流体输送），识别密封失效、应力集中等潜在隐患，优化安装方案。
          </div>

          <div className="PortProductLineSmallTitle">2.安装施工指导</div>
          <div className="PortProductLineText">- 标准化操作培训：</div>
          <div className="PortProductLineText">
            - 指导法兰密封面处理、螺栓预紧力控制、焊接工艺规范等关键操作。
          </div>
          <div className="PortProductLineText">
            - 演示特殊阀门（如低温阀、波纹管密封阀）的安装要点，避免人为损伤。
          </div>
          <div className="PortProductLineText">
            -
            定制化工具支持：提供专用安装工具（如扭矩扳手、对中校准仪）及操作手册，确保施工精度。
          </div>

          <div className="PortProductLineSmallTitle">3.系统调试与优化</div>
          <div className="PortProductLineText">
            -
            联动测试：协助完成阀门与DCS/PLC系统的信号对接，调试开度响应、紧急切断等控制逻辑。{' '}
          </div>
          <div className="PortProductLineText">- 性能调优：</div>
          <div className="PortProductLineText">
            - 通过压力-流量曲线测试，优化调节阀的行程匹配；
          </div>
          <div className="PortProductLineText">
            - 针对气蚀、水锤等问题，调整缓冲装置参数或加装阻尼配件。
          </div>

          <div className="PortProductLineSmallTitle">4.运维技能转移</div>
          <div className="PortProductLineText">
            -
            现场培训：围绕日常点检、故障诊断、备件更换等场景，手把手传授标准化操作流程。
          </div>
          <div className="PortProductLineText">
            -
            知识交付：提供系统操作手册、维护周期表、故障代码库等文档，实现技术能力沉淀。{' '}
          </div>

          <div className="PortProductLineSubtitle">三、核心优势</div>
          <div className="PortProductLineSmallTitle">1.专家团队护航</div>
          <div className="PortProductLineText">
            -
            工程师均具备10年以上行业经验，参与过高纯气体、危化品、氢能等高危险性项目，熟悉ASME、GB等国内外标准。
          </div>
          <div className="PortProductLineText">
            - 配备振动分析仪、热成像仪等专业设备，快速定位隐蔽问题。
          </div>

          <div className="PortProductLineSmallTitle">2.标准化服务流程</div>
          <div className="PortProductLineText">
            -
            从需求诊断→方案制定→驻场执行→验收报告→效果追踪，全程可量化、可追溯。
          </div>
          <div className="PortProductLineText">
            - 建立“一项目一档案”数据库，支持后续运维调取历史数据。
          </div>

          <div className="PortProductLineSmallTitle">3.灵活合作模式</div>
          <div className="PortProductLineText">
            -
            按需提供全程驻场支持或关键节点介入服务，适配客户不同预算与项目周期需求。
          </div>

          <div className="PortProductLineSubtitle">四、典型应用场景</div>
          <div className="PortProductLineText">
            - 新建项目：高危介质管路首次投用前的安装合规性验证。
          </div>
          <div className="PortProductLineText">
            - 改造项目：老旧系统升级中阀门组替换与自动化改造的衔接调试。
          </div>
          <div className="PortProductLineText">
            - 应急抢修：突发泄漏、控制失灵等故障的快速诊断与修复方案制定。
          </div>

          <div className="PortProductLineSubtitle">五、客户价值</div>
          <div className="PortProductLineText">
            - 风险降低：减少60%以上因安装不当导致的密封泄漏或设备损坏。
          </div>
          <div className="PortProductLineText">
            - 效率提升：通过标准化作业指导，缩短30%-50%的施工与调试时间。
          </div>
          <div className="PortProductLineText">
            - 长效收益：培养客户自有团队技术能力，降低后续外包依赖成本。
          </div>
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }
}
